/**
 * Builds an object using the key attribute as attribute and the item as the value.
 * @param keyArray an array of objects containing a key attribute
 */
export default function keyArrayToObject(keyArray) {
  return keyArray.reduce((memo, value) => {
    memo[value.key] = value;
    return memo;
  }, {});
}